import {doc} from '../docs.js';
import {interleaf} from '../datastructures/list.js';
import {delaunayIndex} from './triangulation.js';
import {threeBufferGeometry} from './geometry-3d.js';
import {threeMesh} from './mesh-3d.js';

doc(
    "polygonsToMeshes",
    {
        polygons: "",
        material: ""
    },
    "Converts a list of polygon points to meshes",
    undefined,
    {
        tags: "Graphics",
        inlets: 2
    }
);

export const polygonsToMeshes = (object, material) => {
    let geometries = [];
    let allMeshes = [];
    let meshes = [];
    let indices = [];
    return ([polygons]) => {
        if (!polygons) {
            return;
        }

        let i=0;
        let _meshes = [];
        for (let polygon of polygons) {
            let interleaved = interleaf(object, 0, 2)([polygon]);
            let index  = delaunayIndex(object)([polygon]);
            indices[i] = index && index[0];
            let j = i;
            if (!geometries[i]) {
                geometries[i] = threeBufferGeometry(object, undefined, () => indices[j]);
            }
            let geometry = geometries[i](interleaved);
            if (geometry) {
                if (!meshes[i]) {
                    meshes[i] = threeMesh(object, () => material());
                }
                let mesh = meshes[i](geometry);
                if (mesh) {
                    _meshes.push(mesh[0]);
                    allMeshes.push(mesh[0]);
                }
            }
            i++;
        }
        let meshesToDelete = [];
        let newAllMeshes = [];
        for (let mesh of allMeshes) {
            if (!_meshes.includes(mesh)) {
                meshesToDelete.push(mesh);
            } else {
                newAllMeshes.push(mesh);
            }
        }
        allMeshes = newAllMeshes;
        object.sendMessage(
            object.outputByNumber(0),
            "remove", ... meshesToDelete);
        return [_meshes];
    };
};
